import * as React from "react";
import { useRouteError } from "react-router-dom";
import { ReactComponent as ErrorGeneral } from "../../assets/images/empty-state/error-general.svg";
import { ErrorLayout } from "../../components/layouts/ErrorLayout";
import { getErrorMessageFromError } from "../../utils/errors";

export const ReportIssueError = () => {
  const error: any = useRouteError();
  const message = getErrorMessageFromError(error);

  return (
    <ErrorLayout
      overallTitle="Support Request"
      title="An error occurred while loading this report screen."
      subTitle={message}
    >
      <ErrorGeneral />
    </ErrorLayout>
  );
};
